<div id="sidebar" class="sidebar-offcanvas" data-testid="sidebar">
  <div class="col-md-12">
    <ul class="nav nav-pills nav-stacked">
      <li class="nav-divider"></li>
      <li class="">
        <a [routerLink]="['']" data-testid="sidebar-active-strikes">Active Strikes<i class="fa fa-home fa-fw pull-right"></i></a>
      </li>
      <li class="nav-divider"></li>
      <li>
        <a [routerLink]="['/strikes']" data-testid="sidebar-all-strikes">All Strikes<i class="fa fa-users fa-fw pull-right"></i></a>
      </li>
      <li>
        <a [routerLink]="['/strikes/add']" data-testid="sidebar-new-strike">New Strike<i class="fa fa-plus-circle fa-fw pull-right"></i></a>
      </li>
      <li class="nav-divider"></li>
      <li>
        <a [routerLink]="['/users']" *ngIf="userData.isSuperUser" data-testid="sidebar-users">Users<i class="fa fa-user fa-fw pull-right"></i></a>
      </li>
      <li>
        <a [routerLink]="['/register']" *ngIf="userData.isSuperUser" data-testid="sidebar-new-user">Add New User<i
            class="fa fa-user-plus fa-fw pull-right"></i></a>
      </li>
      <li class="nav-divider" *ngIf="userData.isSuperUser"></li>
      <li>
        <a [routerLink]="['/login']" *ngIf="!userData.isUserLoggedIn" data-testid="sidebar-login">Login<i
            class="fa fa-sign-in fa-fw pull-right"></i></a>
      </li>
      <li>
        <button type="button" class="btn btn-danger btn-sm" (click)="logout()" *ngIf="userData.isUserLoggedIn">
          Logout<i class="fa fa-sign-out fa-fw pull-right" data-testid="sidebar-logout"></i>
        </button>
      </li>
    </ul>
  </div>
</div>
